import React from "react";
import { observer } from "mobx-react-lite";
import {
  Tooltip as MUIToolTip,
  TooltipProps as MUITooltipProps,
  ThemeProvider,
} from "@mui/material";

import "./Tooltip.scss";
import { translationService } from "../../services/translation/TranslationService";
import { MUIComponentsTheme } from "../../services/theme-service/ThemeService";

export interface ComponentWithTooltipProps {
  tooltipTextKey: string;
}

export default observer(function Tooltip(props: MUITooltipProps & { boldedText?: string }) {
  const { title, children, boldedText, ...remainingProps } = props;

  const translatedContent = typeof title === "string" ? translationService.translate(title) : title;

  const translatedBoldedText = boldedText
    ? typeof boldedText === "string"
      ? translationService.translate(boldedText)
      : boldedText
    : undefined;

  const tooltipText = boldedText ? (
    <span className="tooltip-content">
      <span className="bolded">{translatedBoldedText}</span>: {translatedContent}
    </span>
  ) : (
    <span className="tooltip-content">{translatedContent}</span>
  );

  return (
    <ThemeProvider theme={MUIComponentsTheme}>
      <MUIToolTip {...remainingProps} title={tooltipText} arrow>
        {children}
      </MUIToolTip>
    </ThemeProvider>
  );
});
